import React from 'react';
import ExpenseBoard from '../components/ExpenseComps/ExpenseBoard';

const CONFIG = {
    noun: 'Shoot',
    categories: ['Equipment Rental', 'Crew', 'Location', 'Props & Wardrobe', 'Catering', 'Transport', 'Post-production'],
    shootTypes: ['Indoor', 'Outdoor', 'Local'],
    employees: true,
    payTiming: true,
    extraFields: [
        { key: 'project', label: 'Project / Shoot', required: true, choices: true },
        { key: 'location', label: 'Location' },
    ],
};

export { CONFIG as SHOOT_CONFIG };

export default function ShootExpensesPage({ data }) {
    return <ExpenseBoard config={CONFIG} data={data} />;
}
